import React, { memo } from "react";
import { useDisclosure } from '@chakra-ui/react'
import { useEditMenuImage } from "../../../hooks/menu/useEditMenuImage";
import { MenuEditModalLayout } from "./MenuEditModalLayout";

type MenuEditModalProps = {
  id: string;
  mutateKey: string;
}
export const MenuEditModal: React.FC<MenuEditModalProps> = memo(({id, mutateKey}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const onSubmit = useEditMenuImage(id, mutateKey, onClose)
  return (
    <MenuEditModalLayout
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
});